export default {
  eventListPage: {
    city: {
      cityCategoryHorizontalListTitle:
        ' Discover workshops and courses in {city} ',
    },
    teamEventSlugPrefix: 'teambuilding',
    kitsTitle: 'Take your {category} home',
  },
}
